<template>
    <div class="wrapper">
        <h1>{{ t('missingSessionID') }}</h1>
    </div>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
    name: 'InvalidSession',
    setup() {
        const { t, locale } = useI18n();
        return { t, locale };
    }
}

</script>

<style scoped>
.wrapper {
    padding: 4rem;
    padding-top: 100px;
}
</style>